import { render, staticRenderFns } from "./SithMesPrdKamChangeList.vue?vue&type=template&id=827d09f2&"
import script from "./SithMesPrdKamChangeList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdKamChangeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports